import React from "react"
import {DefaultProps, RefTable} from "../RefTable";

export const EMPlatform = (props)=><RefTable {...props}/>;

EMPlatform.defaultProps = {
    ...DefaultProps,
    title: "Integration Platforms",
    tableSchema: "em_platform",
    tableName: "em_platform",
    edit: true,
    add: true
}
